import { useSelector } from "react-redux";
import useCreditoFiscal from "../../../actions/credito-fiscal.actions";
import { ModalBase } from "../../../components/Modals/ModalBase";
import BasicCardDocumentos from "./BasicCardDocumentos";
import { State } from "../../../reducers";
import { useEffect, useState } from "react";
import { Pagination } from "../../../components/Pagination";
import InputForm from "./InputFormV2";

export default function ModalAsociaNotaRemision (){
    const {modal_button_cerrarNotaRemision, actionButton_asociarNotaRemision, actionButton_desasociarNotaRemision, buscarNotasRemision} = useCreditoFiscal()
    const {loader_notasRemision, notasRemisionEncontradas, productos, formCliente} = useSelector((state: State) => state.creditoFiscal)
    const [tableData, setTableData] = useState<Array<any>>([])
    const [filterData, setFilterData] = useState<Array<any>>(notasRemisionEncontradas)
    const [filtros, setFiltros] = useState({
        fechaEmision: '',
        numeroControl: ''
    })

    const onChange = (e: any) => {
        setFiltros({
            ...filtros,
            [e.target.name] : e.target.value
        })
    }

    useEffect(() => {
        setTableData(notasRemisionEncontradas)
    }, [notasRemisionEncontradas.length])

    useEffect(() => {
        let dataFiltrada = notasRemisionEncontradas

        if(filtros.fechaEmision){
            dataFiltrada = dataFiltrada.filter((nota: any) => nota.DetallesDTE.identificacion.fecEmi === filtros.fechaEmision)
        }

        if(filtros.numeroControl.trim() !== ''){
            console.log(filtros.numeroControl);
            
            dataFiltrada = dataFiltrada.filter((nota: any) => nota.codigogeneracion.includes(filtros.numeroControl))
        }

        if(!filtros.fechaEmision && filtros.numeroControl.trim() === ''){
            dataFiltrada = notasRemisionEncontradas
        }

        setFilterData(dataFiltrada)

    }, [filtros])

    return (
        <ModalBase>
            <BasicCardDocumentos title="Asociar nota de remisión">
                {loader_notasRemision ?
                <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px'}}>
                <div className='spinner'></div>
                    Cargando documentos asociados...
                </div>
                 :
                 <>
                 {formCliente.noDocumento.trim() === '' || formCliente.nrc.trim() === '' ?
                    <span>Ingresa NIT y NRC del cliente para buscar notas de remisión disponibles</span>
                    :
                    <>               
                    {notasRemisionEncontradas?.length > 0 ?
                    <div className="tab-plane">
                        <div style={{display: 'flex', marginBottom: '10px', gap: '20px'}}>
                            <InputForm onChange = {onChange} name = 'fechaEmision' label = 'Filtrar por fecha' value = {filtros.fechaEmision} type = 'date'/>
                            <InputForm onChange = {onChange} name = 'numeroControl' label = 'Filtrar por número de control' value = {filtros.numeroControl}/>
                        </div>
                        <table className="table-main-responsive responsive-table-main td-left table-pointer">
                            <thead>
                                <tr>
                                    <td>Correlativo</td>
                                    <td>Número de control</td>
                                    <td>Total</td>
                                    <td>Fecha de emisión</td>
                                    <td>Acciones</td>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((nota) => {
                                    let fecha = nota.DetallesDTE.identificacion.fecEmi.split('-')
                                    let fechaEmision = `${fecha[2]}/${fecha[1]}/${fecha[0]}`
                                    return(
                                        <tr>
                                            <td>{nota.CorrelativoSuscripcion}</td>
                                            <td>{nota.codigogeneracion}</td>
                                            <td>{nota.DetallesDTE.resumen.montoTotalOperacion.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                            <td>{fechaEmision}</td>
                                            <td>
                                                {productos.some((producto) => producto.notaRemisionId === nota.codigogeneracion) ?
                                                    <button onClick={() => actionButton_desasociarNotaRemision(nota.codigogeneracion)} style={{borderRadius: '4px', color: '#FFF', background: 'red'}}>Quitar</button>
                                                    :
                                                    <button onClick={() => actionButton_asociarNotaRemision(nota.DetallesDTE.cuerpoDocumento, nota.codigogeneracion, nota)} style={{borderRadius: '4px'}}>Asociar</button>
                                                }
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        <Pagination items = {5} state = {(items: Array<any>) => setTableData(items)} data = {filterData}/>
                    </div>
                    :
                    <span>No hay notas de remisión disponibles por asociar</span>
                    }
                    </>

                }
                 </>
                }
                
                <div style={{display:'flex', justifyContent: 'center', width: '100%', gap: '20px'}}>
                    <button onClick={modal_button_cerrarNotaRemision} style={{display:'flex', width: '50%'}} className="button transparent">Cerrar</button>
                    <button onClick={buscarNotasRemision} style={{display:'flex', width: '50%'}} className="button">Buscar notas de remisión</button>
                </div>
            </BasicCardDocumentos>
        </ModalBase>
    )
}